import { render, staticRenderFns } from "./RsaConfigurazioneSettingsViewPage.vue?vue&type=template&id=513e01a0"
import script from "./RsaConfigurazioneSettingsViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSettingsViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports